import React from "react";
import Routing from "./routes/routing";
import MaintenancePage from "./components/ErrorBoundary/MaintenancePage";

const MAINTENANCE_MODE = false; // set to true to enable maintenance page

function App() {
  if (MAINTENANCE_MODE) return <MaintenancePage />;

  return (
    <div>
      <Routing />
    </div>
  );
}

export default App;
